import * as z from 'zod';

import { contactQueryLinkerSchema } from '@/_pages/contacts/shared/schemas/contact-query-linker-schema';
import { teamMemberQueryLinkerSchema } from '@/_schemas/team-members/team-members-query-linker-schema';

export const supportFilterSchema = z.object({
  // Search query - for general text search
  search: z.string().optional(),

  // Status filter - multi-select
  status: z.array(z.object({ value: z.string(), label: z.string() })).optional(),

  // Priority filter - multi-select
  priority: z.array(z.object({ value: z.string(), label: z.string() })).optional(),

  // Agent filter - multi-select
  agent: z.array(teamMemberQueryLinkerSchema).optional(),

  // Contact filter - multi-select
  contact: z.array(contactQueryLinkerSchema).optional(),
});

export type SupportFilterSchema = z.infer<typeof supportFilterSchema>;
